import React, { useEffect, useState } from "react";
import AdayProfil from "./AdayProfil";
import PersonelProfil from "./PersonelProfil";

const Profil = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const rol = localStorage.getItem("userRole");
    setUserRole(rol);
  }, []);

  if (userRole === null) return <p>Yükleniyor...</p>;

  return userRole === "personel" ? <PersonelProfil /> : <AdayProfil />;
};

export default Profil;
